srrs.p56 = {
    pageload: function() {
        $x_Show('button_pdf');
        $x_Hide('button_pdf_wait');
    }
};